import * as React from "react";
import { IArea } from "../types/IArea";
import { IStructure } from "../types/IStructure";
import { IProject } from "../types/IProject";

type TOrganixMode = 'init' | 'process' | 'simulate_remote' | 'simulate_diagenix' | 'export' | 'error';

interface ISimulation {
  project: IProject;
  structures: IStructure[];
  area: IArea;
}

interface IOrganixContext {
  mode: TOrganixMode;
  setMode: (mode: TOrganixMode) => void;
  simulation: ISimulation;
}

const OrganixContext = React.createContext<IOrganixContext | null>(null);

const useOrganixContext = (): IOrganixContext => {
  const ctx = React.useContext(OrganixContext);
  if (!ctx) throw new Error('useOrganixContext must be used inside an <OrganixContext> provider.');
  return ctx;
}

export { IOrganixContext, OrganixContext, useOrganixContext, TOrganixMode, ISimulation }
